module.exports = __webpack_public_path__ + "static/media/cargas-verde.bb8d4c78.svg";